import { render, staticRenderFns } from "./NewLicence.vue?vue&type=template&id=a59484ca"
import script from "./NewLicence.vue?vue&type=script&lang=js"
export * from "./NewLicence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports